import * as PIXI from "pixi.js";
import { Debug } from "../../../shared/debug";
import { getQueryParams } from "../../../shared/utils";
import { ColorPalette_Mixed } from "./colorPalette.mixed";
import { ColorPalette_Old } from "./colorPalette.old";

export const Colors = ColorPalette_Mixed;

export function getGradientFromPaletteColor(name: string) {
    const val = (Colors as any)[name];
    let gradientStart;
    let gradientEnd;
    if (val instanceof Array) {
        gradientStart = val[0];
        gradientEnd = val[1];
    }
    else {
        gradientStart = val;
        gradientEnd = val;
    }

    const start = PIXI.utils.hex2rgb(gradientStart);
    const end = PIXI.utils.hex2rgb(gradientEnd);
    const result = `
    colorStart = vec4(${start[0]}, ${start[1]}, ${start[2]}, 1.0);
    colorEnd = vec4(${end[0]}, ${end[1]}, ${end[2]}, 1.0);
    `;
    console.log(`made shader snippet ${result}`);
    return result;
}

console.log('Loaded color palette from url is enabled'); //TODO: This should be compiled out or something
//Handler code for url provided color palette
//document.addEventListener('DOMContentLoaded', function () {

function parseCSSHex(cssHex: string) {
    //Remove leading #
    cssHex = cssHex.replace('#', '');
    return parseInt(cssHex, 16);
}

// Extract the URL of the current document (iframe content)
const currentUrl = window.location.href;

// Get the query parameters
const queryParams = getQueryParams(currentUrl);

const palette = Colors as any;

const gradients = new Map<string, [number, number]>();
for (const key in queryParams) {
    //Extract gradient start and end values if they are provided.
    if (key.includes('_start')) {
        const colorName = key.split('_')[0];
        const value = parseCSSHex(queryParams[key])
        if (!gradients.has(colorName)) {
            gradients.set(colorName, [value, value]);
        }
        else {
            gradients.get(colorName)![0] = value;
        }
    }
    if (key.includes('_end')) {
        const colorName = key.split('_')[0];
        const value = parseCSSHex(queryParams[key])
        if (!gradients.has(colorName)) {
            gradients.set(colorName, [value, value]);
        }
        else {
            gradients.get(colorName)![1] = value;
        }
    }

    //If not a gradient just apply it normally
    if (!key.includes('_start') && !key.includes('_end')) {
        //If it has "UI in the name, apply it as a string"
        if (key.includes('UI')) {
            palette[key] = queryParams[key];
            console.log('setting', key, 'to', queryParams[key]);
        }
        else if (key.includes('Scaler') || key.includes('Power') || key.includes('Alpha')) {
            palette[key] = parseFloat(queryParams[key]);
        }
        else {
            palette[key] = parseCSSHex(queryParams[key]);
            console.log('setting', key, 'to', parseCSSHex(queryParams[key]));
        }
    }
}

//Apply gradient values to palette
for (const [key, value] of gradients) {
    palette[key] = value;
    console.log('setting', key, 'to', value);
}

console.log('Loaded color palette from query string:', queryParams);

//});
